export default {
    bind(el) {
        let headerHeight = document.querySelector('.main-header').offsetHeight;
        let targetOffset = document.querySelector(el.dataset.scrollToThis).getBoundingClientRect().top;

        el.addEventListener('click', e => {
            e.preventDefault();
            window.scrollTo({ top: targetOffset - headerHeight, behavior: 'smooth' });
        });
    },
}
